// $(document).ready(function() {
//     $('.product-card p').slideUp();
//     $('.product-item').hover(
//         function(){ $(this).find('.product-card p').slideDown();},
//         function(){ $(this).find('.product-card p').slideUp();}
//     );
// });